import axiosInstance from "../axiosInstance";

export const fulfillmentRuleService = {
  fetch: async (limit = 15, skip = 0, client_id, searchValue, extraQuery = "") => {
    try {
      let api = `/fulfillment-rule?$sort[createdAt]=-1&$limit=${limit}&$skip=${skip}&$populate=warehouse_priority.warehouse`;
      if (client_id) api += `&client=${client_id}`;
      if (searchValue) api += `&name[$search]=${encodeURIComponent(searchValue)}`;
      if (extraQuery) api += extraQuery;
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchByClient: async (client_id) => {
    try {
      const response = await axiosInstance.get(
        `/fulfillment-rule?client=${client_id}&$sort[createdAt]=-1&$populate=warehouse_priority.warehouse`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await axiosInstance.post("/fulfillment-rule", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.patch(
        `/fulfillment-rule/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/fulfillment-rule/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
